<template>
  <div class="row">
    <div v-if="readingFromBle" class="loading-overlay">
      <LoadingPlaceholder/>
    </div>
    <div class="col-12 d-flex justify--space-between clickable">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
      <i v-if="isBleAvailable" class="fa-brands fa-bluetooth-b" style="font-size: 30px; color: #223fb9" @click="handleBluetoothRead"></i>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="45"
            min="10"
            :error="errors.temperature.length > 0"
            :error-messages="errors.temperature"
            v-model=" form.temperature"
            :placeholder="$t('dashboard_new_evollu.measurement_types.body_temperature_short')+' (ºC)'"
            :label="$t('dashboard_new_evollu.measurement_types.body_temperature_short')+' (ºC)'"
            required
            :v-bind:class="{'error': true}"
            :disabled="measuresFromBle"
          />
        </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import HandleBluetoothMixin
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/HandleBluetoothMixin.vue";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";

const BODY_TEMPERATURE_TYPE_ID = 11

export default {
  components: {LoadingPlaceholder},
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  mixins: [HandleBluetoothMixin],
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        temperature: null,
        equipmentType: null
      },
      errors: {
        temperature: [],
      }
    }
  },
  async created() {
    this.measurement.measurementTypeId = 3
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.temperature !== null && this.form.temperature !== '')
        this.$emit('updateCanSubmit', canSubmit)
    },
  },
  watch: {
    "form.temperature": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 10 || value > 45)) {
        this.errors.temperature = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 10, max: 45})]
      }
      else {
        this.errors.temperature = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BODY_TEMPERATURE_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_TEMPERATURE_TYPE_ID)
        elem.value = this.errors.temperature.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.temperature.length === 0 ? value : null,
          typeId: BODY_TEMPERATURE_TYPE_ID,
          equipmentType: this.form.equipmentType
        })
      }
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
